module.exports = __webpack_public_path__ + "media/images/google-play-badge_135px-b998a625.png";